(function () {
  'use strict';

  var ROOT_MARGIN = '400px 0px';
  var SELECTOR = '[data-lazy-section]';

  function sectionRoot(placeholder) {
    return placeholder.closest('.shopify-section') || placeholder;
  }

  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function activateMedia(root) {
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) return;
      try {
        img.loading = 'lazy';
      } catch (e) {}
    });
  }

  function fetchSectionHtml(sectionId) {
    var url =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') +
      '?sections=' +
      encodeURIComponent(sectionId);

    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Section fetch failed: ' + sectionId);
      return response.json();
    }).then(function (payload) {
      var html = payload && payload[sectionId];
      if (!html) throw new Error('Missing section HTML: ' + sectionId);
      return html;
    });
  }

  function hydrate(placeholder) {
    if (placeholder.dataset.lazyState === 'loading' || placeholder.dataset.lazyState === 'done') {
      return Promise.resolve();
    }

    var sectionId = placeholder.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();

    placeholder.dataset.lazyState = 'loading';
    var root = sectionRoot(placeholder);

    return fetchSectionHtml(sectionId)
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html.trim();
        var next = template.content.firstElementChild;
        if (!next) throw new Error('Empty section HTML: ' + sectionId);

        root.replaceWith(next);
        runScripts(next);
        activateMedia(next);

        if (typeof window.ensureAnimations === 'function' && next.querySelector('.scroll-trigger')) {
          window.ensureAnimations();
        }

        document.dispatchEvent(
          new CustomEvent('lazy-section:loaded', {
            detail: { sectionId: sectionId, section: next }
          })
        );
      })
      .catch(function () {
        placeholder.dataset.lazyState = 'error';
      });
  }

  function observe(placeholders) {
    if (!placeholders.length) return;

    if (!('IntersectionObserver' in window)) {
      placeholders.forEach(hydrate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0.01 }
    );

    placeholders.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    observe(Array.prototype.slice.call(document.querySelectorAll(SELECTOR)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    observe(Array.prototype.slice.call(document.querySelectorAll(SELECTOR)));
  });
})();
